import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FallbackImage from './FallbackImage';
import { CALENDLY_URL } from '../config';

const Header = () => {
  const location = useLocation();
  const isFa = location.pathname.startsWith('/fa');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // For fullpage scroll: section changes fire fp:change; fallback to window.scrollY for normal pages
    const onFpChange = (e) => setScrolled(e.detail.index > 0);
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('fp:change', onFpChange);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('fp:change', onFpChange);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const bookNow = (e) => {
    if (window.Calendly) {
      e.preventDefault();
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    }
  };

  return (
    <nav className={`navbar navbar-expand-lg navbar-light fixed-top${scrolled ? ' navbar-scrolled' : ''}`}>
      <div className="container">
        <FallbackImage src="/mb.png" alt="Logo" style={{ maxWidth: '68px', height: 'auto', margin: '0 12px 0 0', display: 'block' }} />
        <a className="navbar-brand" href="#about">Mitra Behboudi</a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navMenu" aria-controls="navMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navMenu">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
            <li className="nav-item ms-1">
              {isFa ? (
                <a className="nav-link" href="/">🇬🇧 English</a>
              ) : (
                <a className="nav-link" href="/fa">🇮🇷 فارسی</a>
              )}
            </li>
            <li className="nav-item"><a className="nav-link" href="#about">About</a></li>
            <li className="nav-item"><a className="nav-link" href="#expertise">Expertise</a></li>
            <li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
            <li className="nav-item"><a className="nav-link" href="#issues">Issues</a></li>
            <li className="nav-item"><a className="nav-link" href="#testimonials">Testimonials</a></li>
            <li className="nav-item"><a className="nav-link" href="#faq">FAQ</a></li>
            <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
            <li className="nav-item ms-2">
              <a
                href={CALENDLY_URL}
                target="_blank"
                rel="noreferrer"
                onClick={bookNow}
                className="btn btn-primary btn-sm"
                style={{ padding: '0.45rem 1.3rem', fontSize: '0.88rem' }}
              >
                Book Free Consult
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
